import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQBreadcrumb from '../../components/breadcrumb';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'crumbs', type: 'string[]', default: '[]', description: 'Array of breadcrumb labels.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
import UQBreadcrumb from '@uniqconsulting/ui/components/breadcrumb';

<UQBreadcrumb crumbs={['Home', 'Section', 'Subsection']} />
`;

const BreadcrumbDemoPage = () => (
  <>
    <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Breadcrumb']} />
    <h1>UQBreadcrumb Demo</h1>
    <UQSpacer size="m" />

    <h2>Description</h2>
    <p>
      <code>UQBreadcrumb</code> displays a navigation trail for the current page, helping users understand their location within the app.
    </p>
    <UQSpacer size="m" />

    <h2>Attributes</h2>
    <UQSpacer size="s" />
    <UQDataGrid
      items={attributes}
      columns={attributeColumns}
      sortable={false}
      selectionMode="none"
      rowLines
    />
    <UQSpacer size="m" />

    <h2>Examples</h2>
    <UQSpacer size="s" />
    <UQBreadcrumb crumbs={['Home', 'Section', 'Subsection']} />
    <UQSpacer size="m" />

    <h2>Code Example</h2>
    <UQCode code={codeExample.trim()} enableCopy />
  </>
);

export default BreadcrumbDemoPage;